import { ForwardedRef, forwardRef, memo } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { BoxVariantProps } from '../Box.types';
import useStyle from '../../../hooks/useStyle';

function BoxDefault(
  {
    id,
    animatedStyle,
    entering,
    exiting,
    children,
    onLayout,
    renderToHardwareTextureAndroid,
    testID,
    ...rest
  }: BoxVariantProps,
  ref: ForwardedRef<View>,
) {
  const style = useStyle(rest);
  const Component = animatedStyle || entering || exiting ? Animated.View : View;

  return (
    <Component
      ref={ref}
      id={id}
      style={animatedStyle ? [style, animatedStyle] : style}
      entering={entering}
      exiting={exiting}
      onLayout={onLayout}
      renderToHardwareTextureAndroid={renderToHardwareTextureAndroid}
      testID={testID}
    >
      {children}
    </Component>
  );
}

export default memo(forwardRef(BoxDefault));
